import { useMemo } from 'react';
import { Stage } from '@/types/projects';
import { useProjectStore } from '@/store/projectStore';

export const useStageProgress = (stages: Stage[]) => {
  const { substages, tasks } = useProjectStore();

  return useMemo(() => {
    const progress: Record<string, { progress: number; totalTasks: number; completedTasks: number; }> = {};

    stages.forEach(stage => {
      const stageSubstages = substages.filter(s => s.stage_id === stage.id);
      const stageTasks = tasks.filter(t => 
        stageSubstages.some(s => s.id === t.substage_id)
      );

      const totalTasks = stageTasks.length;
      const completedTasks = stageTasks.filter(t => t.status === 'completed').length;

      progress[stage.id] = {
        totalTasks,
        completedTasks,
        progress: totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0
      };
    });

    return progress;
  }, [stages, substages, tasks]);
};